import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyState.vue?vue&type=style&index=0&id=3f1d29ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\Projects\\Commercial\\GEMA\\Ga-East-Municipal-Assembly\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f1d29ba"]])

export default __exports__